/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.FlashMessages')
    .factory('flashMessagesService', ['$timeout', function ($timeout) {
        var
            messages = [],
            observers = [],
            currentIndex;

        return {
            ERROR: 'error',
            SUCCESS: 'success',
            NOTICE: 'notice',
            INFO: 'info',
            CSS_CLASSES: {
                error: 'danger',
                success: 'success',
                notice: 'notice',
                info: 'info'
            },
            DELAY_SUCCESS_REMOVE: 3000,

            getMessages: function () {
                return messages;
            },

            add: function (msg, type, hideTimeout, showSuccessInModal = false) {
                var message = {
                    type: type,
                    text: msg,
                    cssClass: this.CSS_CLASSES[type],
                    hideTimeout: hideTimeout || this.DELAY_SUCCESS_REMOVE,
                    showSuccessInModal
                };

                if (observers.length >= 1 && observers[observers.length - 1].canHandle(message)) {
                    observers[observers.length - 1].handle(message);
                } else {
                    var newMessageIndex = messages.push(message) - 1;
                    currentIndex = messages.length - 1;
                    if (type == this.SUCCESS) {
                        this.cleanUp(message);
                    }
                }
            },

            getCurrent: function () {
                return messages[currentIndex];
            },

            getPublicIndex: function () {
                return (currentIndex + 1)
            },

            next: function () {
                if (currentIndex == (this.count() - 1)) return;
                currentIndex += 1;
            },

            previous: function () {
                if (currentIndex == 0) return;
                currentIndex -= 1;
            },

            reload: function () {
                currentIndex = currentIndex;
            },

            any: function () {
                return 1 <= messages.length;
            },


            count: function () {
                return messages.length;
            },

            remove: function () {
                messages.splice(currentIndex, 1);
                if (currentIndex == this.count()) this.previous();
            },

            cleanUp: function (messageToRemove) {
                var service = this;
                $timeout(function () {
                    var messageIndexToRemove = messages.indexOf(messageToRemove);
                    messages.splice(messageIndexToRemove, 1);

                    if (currentIndex == service.count()) {
                        service.previous();
                    }
                }, messageToRemove.hideTimeout);
            },

            subscribe: function (callback) {
                observers.push(callback);
            },

            unsubscribe: function () {
                observers.pop();
            }
        };
    }]);
